export { default } from '../shared/lib/dynamic'
export * from '../shared/lib/dynamic'
